'use client';

import { Box } from '@terra/ui-styled-system';
import { Cancel01Icon } from '@terra/ui-icons';
import { MetaDefault } from '../../components/typography';
import { BUSINESS_UNIT_TAG_MAX_WIDTH_PX } from './business-unit-selector.model';

export const BusinessUnitTagMeasure = ({ name }: { name: string }) => (
  <Box
    data-measure-tag=""
    display="inline-flex"
    alignItems="center"
    gap={1}
    bg="bg.neutral.subtle"
    borderWidth="1px"
    borderColor="border.neutral.default"
    borderRadius="xs"
    px={1}
    flexShrink={0}
    maxW={`${BUSINESS_UNIT_TAG_MAX_WIDTH_PX}px`}
    minW={0}
  >
    <MetaDefault fontWeight="medium" truncate title={name}>
      {name}
    </MetaDefault>
    <Cancel01Icon size={12} aria-hidden />
  </Box>
);

export const BusinessUnitOverflowChip = ({
  hiddenCount,
  hiddenNames,
  measureOverflow,
}: {
  hiddenCount: number;
  hiddenNames: readonly string[];
  measureOverflow?: boolean;
}) => (
  <Box
    data-measure-overflow={measureOverflow ? hiddenCount : undefined}
    display="inline-flex"
    alignItems="center"
    bg="bg.neutral.subtle"
    borderWidth="1px"
    borderColor="border.neutral.default"
    borderRadius="xs"
    px={1}
    flexShrink={0}
    h="22px"
    title={hiddenNames.length > 0 ? hiddenNames.join(', ') : undefined}
  >
    <MetaDefault fontWeight="medium" color="fg.neutral.default">
      +{hiddenCount}
    </MetaDefault>
  </Box>
);
